<template>
  <el-dialog
    v-if="visible"
    v-el-dialog-drag
    :visible="visible"
    show-close
    width="800px"
    :title="title"
    :modal="false"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :before-close="() => $refs.main.cancel()"
  >
    <Main
      ref="main"
      :listAmzSkuCode="listAmzSkuCode"
      @close="close()"
      @success="$emit('success')"
    />

    <span slot="footer">
      <el-button size="small" @click="$refs.main.cancel()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button type="primary" size="small" @click="$refs.main.save()">
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    listAmzSkuCode: { type: Array, default: () => [] },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
